import React from 'react'

export default function Brochure() {
    return(
        <div style={{textAlign:'center', padding: '100px'}}>
            <h1 className='main-title'>Brochure</h1>
            <iframe src="https://drive.google.com/file/d/1CI0F5rEKEQnmFiy7dmOboo3o7x2AwKva/preview" className='brochure' allow="autoplay"></iframe>
        </div>
    )
}